import { render } from "./PlaceLinking.vue?vue&type=template&id=8fb4e94a"
import script from "./PlaceLinking.vue?vue&type=script&lang=js"
export * from "./PlaceLinking.vue?vue&type=script&lang=js"

import exportComponent from "/Users/tasselchof/CodeProjects/oarus/oarus-app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__
import QSelect from 'quasar/src/components/select/QSelect.js';
import qInstall from "../../../../../../../oarus-app/node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QSelect});
